import { z } from 'zod';

// These are the default values for the database, so if we return values directly from the database inside a resolver,, we can merge their schema with these values
export const defaultDBValues = z.object({
    _id: z.string(),
    _lastPosition: z.number().nullable(),
    _operation: z.number().nullable(),
});
